import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Input, Icon, Button, Collapse, Spin, Popconfirm, Modal, Radio, TimePicker, Form, Tabs } from 'antd'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import { UrlMeeting } from '../../../../utils/auth'
import { changeFormatdateSlip } from '../../../../utils/formatdate'
import { downloadFile } from '../../../../utils/downloadFile'
import moment from 'moment/min/moment-with-locales';
import axios from 'axios';
import { WatDatePicker } from "thaidatepicker-react";
import iconDeclineRed from '../../../../assets/images/icons/icon-decline-red.png'
import iconInfoYellow from '../../../../assets/images/icons/icon-info-yellow.png'
import iconSummitGreen from '../../../../assets/images/icons/icon-summit-green.png'
import iconSwap from '../../../../assets/images/icons/icon-swap.png'
import axiosAPI from '../../../../config/axiosAPI'

const { TextArea } = Input;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const { Box } = Panel;

class SentNoteMeetingForm extends React.Component {

    state = {
        idMeeting: null,
        dataMeeting: {
            Comments: [
                {
                    title: "",
                    firstName: "",
                    lastName: "",
                }
            ]
        },
        ApproverDetail: [],
        OrganizerDetail: [],
        GuestsInvite: [],
        OtherGuestsInvite: [],
        Summaries: [],
        preload: null,
        statusAccept: null,
        loadingScreen: false,
        expandCollapse: false,
        onAddFile: false,
        uploadFile: [],
        fileList: [],
        summaryInactive: [],
        countLike: 0,
        countComment: 0,
        showEditcomment: false,
        modalConfirm: false,
        modalSuccess: false,
        isSetTime: false,
        summaryDueDate: "",
        editTime: false,
        isSummaryDueDateActive: false,
        cancelFromEdit: false,
        showModalInvitee: false,
        comments: [],
        commentAccept: null,
    }

    componentDidMount = async () => {
        await this.fetchDataMeeting();
    }
    fetchDataMeeting = async () => {

        const queryString = require('query-string');
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.id) await this.setState({ idMeeting: parsed.id })
        // console.log("parsed.id", parsed.id);
        this.setState({ loadingScreen: true })
        await axiosAPI.post(`${UrlMeeting()}/meeting/secure/meetingdetail`,
            {
                MeetingID: parsed.id
            })
            .then(response => {
                const data = response.data.status.message
                this.setState({
                    dataMeeting: data[0] ? data[0] : [],
                    ApproverDetail: data[1].ApproverDetail ? data[1].ApproverDetail : [],
                    OrganizerDetail: data[1].OrganizerDetail ? data[1].OrganizerDetail : [],
                    GuestsInvite: data[0].Guests ? data[0].Guests : [],
                    OtherGuestsInvite: data[0].OtherGuests ? data[0].OtherGuests : [],
                    preload: false,
                    Summaries: data[0].Summaries && data[0].Summaries.length > 0 ? data[0].Summaries : [],
                    loadingScreen: false,
                    summaryDueDate: data[0]?.summaryDueDate ? data[0]?.summaryDueDate : "",
                    isSummaryDueDateActive: data[0]?.isSummaryDueDateActive ?? false,
                    isSetTime: data[0]?.isSummaryDueDateActive ?? false,
                    editTime: data[0]?.isSummaryDueDateActive ?? false,
                    cancelFromEdit: data[0]?.isSummaryDueDateActive ?? false,
                })
                console.log("data", data);
                const found = (data[0].Comments).find(obj => {
                    return obj.userID === sessionStorage.getItem('username');
                });
                console.log("data[0].Comments", data[0].Comments);
                if (data[0].Comments && found.status == "Accept") {
                    this.setState({
                        statusAccept: found.status,
                    });
                }

                if (data[0].Comments && data[0].Comments.length > 0) {
                    const filterLike = data[0].Comments.filter(o => o.status == "Accept")
                    const countLike = [...new Set(filterLike.map((o) => o.userID))].length;

                    const filterComment = data[0].Comments.filter(o => o.changeDetail != null)
                    const countComment = [...new Set(filterComment.map((o) => o.userID))].length;
                    const sortComment = data[0].Comments.sort((a, b) => moment(b.createDate) - moment(a.createDate))

                    const findCommentAccept = filterComment.some(o => o.userID === sessionStorage.getItem('username'))

                    this.setState({
                        countLike,
                        countComment,
                        comments: sortComment,
                        commentAccept: findCommentAccept,
                    });
                }

                let countInternal = 0;
                let countExternal = 0;
                data[0].Guests.forEach(element => {
                    if (element.StatusResponse.statusName != "Waiting") {
                        countInternal = countExternal + 1;
                    }
                    this.setState({ countInternal });
                });
                data[0].OtherGuests.forEach(element => {
                    if (element.StatusResponse.statusName != "Waiting") {
                        countExternal = countExternal + 1;
                    }
                    this.setState({ countExternal });
                });

            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
    }

    getLength = (arr) => {
        if (arr) {
            return arr.length;
        }
    }

    getLengthAcceptInternal = (data) => {
        return data.filter(o => o.StatusResponse.statusName.toLowerCase() == "join").length
    }

    getLengthAcceptExternal = (data) => {
        return data.filter(o => o.asRole == "1").length
    }

    onChangeExpandCollapse = () => {
        this.setState({ expandCollapse: !this.state.expandCollapse });
    }

    acceptAddFile = async (isSaveFile) => {
        this.setState({ modalConfirm: false })

        let dueDate = null;
        if (this.state.isSetTime && !isSaveFile) {
            dueDate = moment(this.props.form.getFieldValue("endDate")).format("YYYY-MM-DD") +
                " " + moment(this.props.form.getFieldValue("endTime")).format("HH:mm:mm.663")
        }

        const params = {
            MeetingID: this.state.idMeeting,
            UserID: sessionStorage.getItem("username"),
            SummaryNew: isSaveFile ? this.state.uploadFile : [],
            SummaryInactive: isSaveFile ? this.state.summaryInactive : [],
            SummaryDueDate: dueDate,
            type: isSaveFile ? 'summary_file' : 'due_date'
        }
        this.setState({ loadingScreen: true })
        await axiosAPI.post(`${UrlMeeting()}/meeting/secure/updateSummaryMeeting`, params)
            .then(async response => {
                // const data = response.data.status.message
                this.setState({
                    onAddFile: false,
                    fileList: [],
                    uploadFile: [],
                    loadingScreen: false,
                    modalSuccess: isSaveFile,
                    editTime: true,
                });

                setTimeout(() => this.setState({ modalSuccess: false }), 1500)

                await this.fetchDataMeeting();

            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
    }

    handleAddFile = () => {
        this.setState({
            onAddFile: true,
            uploadFile: [],
            summaryInactive: [],
            fileList: this.state.Summaries
        })
    }

    cancelAddFile = () => {
        this.setState({
            onAddFile: false,
            fileList: [],
            uploadFile: [],
            summaryInactive: []
        });
    }

    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    checkFileType = (typeFile) => {
        if ([".presentationml.presentation", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.slideshow", "application/vnd.openxmlformats-officedocument.presentationml.presentation"].includes(typeFile)) {
            return "ppt";
        } else if ([".spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"].includes(typeFile)) {
            return "excel";
        } else if ([".wordprocessingml.document", "application/msword", ".doc", ".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(typeFile)) {
            return "words";
        } else if (["application/pdf"].includes(typeFile)) {
            return "PDF";
        } else if (["image/png"].includes(typeFile)) {
            return "png";
        } else if (["image/jpeg"].includes(typeFile)) {
            return "jpg"
        } else if (["application/zip", "application/x-zip-compressed", "multipart/x-zip"].includes(typeFile)) {
            return "zip"
        }
    };

    changeHandler = async (event) => {
        if (event) {

            if (![
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
                ".doc",
                ".docx",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/pdf",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "image/png",
                "image/jpeg",
                "application/zip",
                "application/x-zip-compressed",
                "multipart/x-zip"].includes(event.target.files[0].type)) {
                return false;
            }

            let fileList = this.state.fileList;
            let uploadFile = this.state.uploadFile;
            const file = event.target.files[0];
            let fileName = event.target.files[0].name;
            let fileType = this.checkFileType(event.target.files[0].type);
            const fileData = await this.convertBase64(event.target.files[0]);
            uploadFile.push({ fileName, fileType, fileData });


            file.fileType = fileType
            fileList = [...fileList, file];

            this.setState({
                fileList,
                uploadFile,
            });
        }
    };

    destroyFileList = async (arrayId, fileId = null) => {
        const { fileList, summaryInactive } = this.state;
        let arrayDataSource = [...this.state.fileList];
        let addSummaryInactive = summaryInactive;
        arrayDataSource.splice(arrayId, 1);

        let arrayDataSourceUploadFile = [...this.state.uploadFile];
        arrayDataSourceUploadFile.splice(arrayId, 1);

        if (fileId) {
            let arrayObjectPush = {
                summaryID: fileId,
            };
            addSummaryInactive.push(arrayObjectPush);
        }

        console.log("arrayDataSource", arrayDataSource);
        this.setState(
            {
                fileList: arrayDataSource,
                uploadFile: arrayDataSourceUploadFile,
                summaryInactive: addSummaryInactive,
            },
            async () => { }
        );
    };

    iconFile = (type) => {
        if (["pdf", "PDF"].includes(type)) {
            return "file-pdf";
        } else if (["doc", "docx", "words"].includes(type)) {
            return "file-word";
        } else if (["xlsx", "excel"].includes(type)) {
            return "file-excel";
        } else if (["ppt", "pptx"].includes(type)) {
            return "file-ppt";
        } else if (["png", "jpg"].includes(type)) {
            return "file-image"
        } else if (["zip"].includes(type))
            return "file-zip"
        else {
            return "file";
        }
    }

    getDisabledHoursEnd = () => {
        let hours = [];

        const endDate = moment(this.props.form.getFieldValue("endDate")).format(
            "DD-MM-YYYY"
        );

        const currentDate = moment().format("DD-MM-YYYY");

        if (endDate === currentDate) {
            for (let i = 0; i < moment().hour(); i++) {
                hours.push(i);
            }
        }
        return hours;
    };

    getDisabledMinutesEnd = (selectedHour) => {
        let minutes = [];

        const endDate = moment(this.props.form.getFieldValue("endDate")).format(
            "DD-MM-YYYY"
        );

        const currentDate = moment().format("DD-MM-YYYY");

        if (endDate === currentDate) {
            if (selectedHour === moment().hour()) {
                for (let i = 0; i < moment().minute(); i++) {
                    minutes.push(i);
                }
            }
        }
        return minutes;
    };

    onChangeTimeRadio = (e) => {

        if (!e.target.value) {
            this.props.form.setFieldsValue({
                endDate: '',
                endTime: ''
            });
        }

        if (e.target.value && this.state.isSummaryDueDateActive) {
            this.props.form.setFieldsValue({
                endDate: this.state.summaryDueDate,
                endTime: moment(this.state.summaryDueDate),
            });

            this.setState({
                isSetTime: e.target.value,
                editTime: true,
                cancelFromEdit: false
            })
        } else {
            this.setState({
                isSetTime: e.target.value,
                editTime: false,
                cancelFromEdit: false
            })
        }

    }
    onChangeEndDate = () => {
    }


    handleSubmit = () => {
        this.setState({ modalConfirm: true })
    }

    onSaveDueDate = (e) => {
        e.preventDefault();
        if (this.state.isSetTime) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    this.acceptAddFile(false);
                }
            });
        } else {
            this.acceptAddFile(false);
        }
    }

    onCancelSetTime = () => {
        if (this.state.cancelFromEdit) {
            this.setState({ editTime: true })
            this.props.form.setFieldsValue({
                endDate: this.state.summaryDueDate,
                endTime: moment(this.state.summaryDueDate)
            });
        } else {
            this.setState({ isSetTime: false });
            this.props.form.setFieldsValue({
                endDate: '',
                endTime: ''
            });
        }
    }

    onEditSetTime = () => {
        this.setState({
            cancelFromEdit: true,
            editTime: false
        })
    }

    onCloseModalInvitee = () => {
        this.setState({ showModalInvitee: false })
    }

    selectIconPath = (status) => {
      switch (status) {
          case 'Waiting':
              return iconInfoYellow
          case 'Join':
              return iconSummitGreen
          case 'Refuse':
              return iconDeclineRed
          case 'Agent':
              return iconSwap
          case '1':
              return iconInfoYellow
          case '2':
              return iconSummitGreen
      }
  }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { match } = this.props

        const { dataMeeting, OrganizerDetail, ApproverDetail, OtherGuestsInvite, Summaries, GuestsInvite, onAddFile, summaryInactive, fileList, uploadFile, countLike, countComment, showEditcomment } = this.state
        const dateTime = !(dataMeeting?.startDate && dataMeeting?.endDate) ? "" : `${changeFormatdateSlip(moment(dataMeeting.startDate))} / ${moment(dataMeeting.startDate).format('HH:ss')} - ${moment(dataMeeting.endDate).format('HH:ss')} น.`
        const dueDate = this.state.summaryDueDate || '';
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalConfirmErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}

                <Spin tip="Loading..." size="large" spinning={this.state.loadingScreen} style={{ alignItems: 'center', position: 'initial' }}>
                    <div className="card-container meeting-management" id="form-meeting">
                        <div className="card-bg-white">
                            <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                                <Col xs={19} >
                                    <Link
                                        to={{
                                            pathname: `/meetingmanagement/waitMeeting`,
                                        }}>
                                        <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> รายละเอียดการส่งบันทึกหลังการประชุม</p>
                                    </Link>
                                </Col>
                            </Row>
                            <Row gutter={16} type="flex">
                                <Col lg={{ span: 20, offset: 2 }} >
                                    <Row className="px-5 py-3 pb-5" gutter={16} type="flex" align="top">
                                        <Col xs={24} className="pt-3">
                                            <p className="text-title-meeting">ส่งบันทึกหลังการประชุม</p>
                                        </Col>
                                        <div>
                                            <Col xs={12}>
                                                <Icon type="user" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ผู้เชิญประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{OrganizerDetail.title} {OrganizerDetail.firstName} {OrganizerDetail.lastName}</p>
                                            </Col>
                                            {ApproverDetail.length != 0 ?
                                                < Col xs={12}>
                                                    <Icon type="user" className="icon-fonttext-meeting" />
                                                    <p className="text-title-meeting ml-2 mb-0">ผู้อนุมัติการประชุม</p><br />
                                                    <p className="text-detail-meeting ml-2">{ApproverDetail.firstName} {ApproverDetail.lastName}</p>
                                                </Col>
                                                :
                                                <></>
                                            }
                                            <Col xs={24} className="pt-3">
                                                <Icon type="menu" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">หัวข้อการประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{dataMeeting.subject}</p>
                                            </Col>

                                            <Col xs={12} className="pt-3">
                                                <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">กำหนดการ</p><br />
                                                <p className="text-detail-meeting ml-2">{moment(dataMeeting.startDate).locale('th').add(543, 'year').format('DD MMMM YYYY')} / {moment(dataMeeting.startDate).format('HH:mm')} - {moment(dataMeeting.endDate).format('HH:mm')} น.</p>
                                            </Col>
                                            <Col xs={12} className="pt-3">
                                                <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0" style={{ display: 'inline' }}>วันที่ออกเอกสาร</p><br />
                                                <p className="text-detail-meeting ml-2" style={{ display: 'inline' }}>{dataMeeting.documentDate ? moment(dataMeeting.documentDate).locale('th').add(543, 'year').format('DD MMMM YYYY') : "-"}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="environment" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">สถานที่จัดการประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{dataMeeting.location}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="team" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">รายชื่อผู้ถูกเชิญ ({GuestsInvite.length + OtherGuestsInvite.length})</p>
                                                <span onClick={() => this.setState({ showModalInvitee: true })} style={{ color: '#3C8BE9', cursor: 'pointer' }}>{"  ดูเพิ่มเติม"}</span>
                                                <br />
                                            </Col>

                                            <Col xs={12} className="pt-3">
                                                <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายใน ({this.getLengthAcceptInternal(GuestsInvite)}/{GuestsInvite.length})</p><br />

                                                {
                                                    GuestsInvite.map((element, i) => {
                                                        if (i >= 5) {
                                                            return <></>
                                                        }
                                                        return (<p className="text-detail-meeting ml-2">{i + 1}. {element.title} {element.firstName} {element.lastName}<br /></p>)
                                                    }
                                                    )
                                                }
                                            </Col>
                                            <Col xs={12} className="pt-3">
                                                <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายนอก ({this.getLengthAcceptExternal(OtherGuestsInvite)}/{OtherGuestsInvite.length})</p><br />
                                                {
                                                    OtherGuestsInvite.map((element, i) => {
                                                        if (i >= 5) {
                                                            return <></>
                                                        }
                                                        return (<p className="text-detail-meeting ml-2">{i + 1}. {element.name}<br /></p>)
                                                    }
                                                    )
                                                }
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="menu" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">รายละเอียด</p><br />
                                                <p className="text-detail-meeting ml-2">{dataMeeting.detail}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="video-camera" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ลิงค์การประชุม</p><br />
                                                <a href={dataMeeting.meetingURL} target='_blank' className="ml-4">{dataMeeting.meetingURL}</a>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="paper-clip" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ไฟล์แนบ</p><br />
                                                {
                                                    (
                                                        dataMeeting.Attacheds ? dataMeeting.Attacheds : []).map((file, i) =>
                                                            <Row>
                                                                <a className="ml-4" onClick={() => {
                                                                    downloadFile(`${UrlMeeting()}/meeting/file/${file.fileNameGen}`, file.fileName)
                                                                }}>{file.fileName}</a>
                                                            </Row>
                                                        )
                                                }
                                            </Col>
                                        </div>
                                        {onAddFile ?
                                            <Col xs={24} className="mt-5">
                                                <Col xs={24} className="pt-3">
                                                    <p>แนบไฟล์บันทึกหลังการประชุม</p>
                                                </Col>
                                                <Col xs={24} className={'mb-3'}>
                                                    <Col xs={24} lg={8} style={{ marginRight: '10px', width: '130px' }}>
                                                        <Button onClick={() => this.refs.fileInput.click()} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff", width: '130px' }}>
                                                            <Icon type="upload" />
                                                            อัพโหลดไฟล์
                                                        </Button>
                                                    </Col>
                                                    <Col xs={24} md={24} lg={16}>
                                                        <span style={{ color: '#aaa' }}>{" (PDF,Word,Excel,PowerPoint,Picture,Zip)"}</span>
                                                    </Col>
                                                </Col>
                                                <input
                                                    ref="fileInput"
                                                    id="input-file"
                                                    name="input-file"
                                                    className="input-file"
                                                    type="file"
                                                    onChange={this.changeHandler}
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                                    application/vnd.ms-excel,
                                                    .doc,
                                                    .docx,
                                                    application/msword,
                                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                                    application/pdf,
                                                    application/vnd.ms-powerpoint,
                                                    application/vnd.openxmlformats-officedocument.presentationml.slideshow,
                                                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                                    image/png,
                                                    image/jpeg,
                                                    application/zip,
                                                    application/x-zip-compressed,
                                                    multipart/x-zip"
                                                />
                                                {this.state.fileList.map((file, i) => {
                                                    return (
                                                        <div>
                                                            <p
                                                                style={{
                                                                    color: "gray",
                                                                    padding: "3px 16px",
                                                                    display: "inline-block",
                                                                    border: "1px solid gray",
                                                                    borderRadius: "20px",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                <Icon type={this.iconFile(file.fileType)} className="pr-3" />
                                                                {file.id ? (
                                                                    <a
                                                                        style={{ color: "gray" }}
                                                                        onClick={() => {
                                                                            downloadFile(`${UrlMeeting()}/meeting/file/${file.fileNameGen}`, file.fileName)
                                                                        }}
                                                                    >
                                                                        {file.fileName}
                                                                    </a>
                                                                ) : (
                                                                    <a style={{ color: "gray" }}>{file.name}</a>
                                                                )}
                                                                {file.id ? (
                                                                    <Popconfirm
                                                                        placement="topLeft"
                                                                        title={"คุณต้องการลบไฟล์แนบเอกสารนี้"}
                                                                        onConfirm={() =>
                                                                            this.destroyFileList(i, file.id)
                                                                        }
                                                                        okText="ตกลง"
                                                                        cancelText="ยกเลิก"
                                                                    >
                                                                        <Icon
                                                                            type="close"
                                                                            className="pl-3 color-red"
                                                                        />
                                                                    </Popconfirm>
                                                                ) : (
                                                                    <Popconfirm
                                                                        placement="topLeft"
                                                                        title={"คุณต้องการลบไฟล์แนบเอกสารนี้"}
                                                                        onConfirm={() => this.destroyFileList(i)}
                                                                        okText="ตกลง"
                                                                        cancelText="ยกเลิก"
                                                                    >
                                                                        <Icon
                                                                            type="close"
                                                                            className="pl-3 color-red"
                                                                        />
                                                                    </Popconfirm>
                                                                )}
                                                            </p>
                                                        </div>
                                                    );
                                                })}
                                            </Col>
                                            :
                                            <Col xs={24} className="mt-5">
                                                <Button onClick={this.handleAddFile} className={'button-meeting-bg-red mt-3 mt-lg-0 mb-4'} style={{ padding: '20px !important', width: 'auto' }} >
                                                    แนบไฟล์บันทึกหลังการประชุม
                                                    <Icon type="form" />
                                                </Button>

                                                {Summaries && Summaries.length > 0 &&
                                                    (Summaries.map((file, i) => {
                                                        return (
                                                            <div>
                                                                <p
                                                                    style={{
                                                                        color: "gray",
                                                                        padding: "3px 16px",
                                                                        display: "inline-block",
                                                                        border: "1px solid gray",
                                                                        borderRadius: "20px",
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    <Icon type={this.iconFile(file.fileType)} className="pr-3" />
                                                                    {file.id ? (
                                                                        <a
                                                                            style={{ color: "gray" }}
                                                                            onClick={() => {
                                                                                downloadFile(`${UrlMeeting()}/meeting/file/${file.fileNameGen}`, file.fileName)
                                                                            }}
                                                                        >
                                                                            {file.fileName}

                                                                        </a>
                                                                    ) : (
                                                                        <a style={{ color: "gray" }}>{file.fileName}</a>
                                                                    )}
                                                                </p>
                                                            </div>
                                                        )
                                                    }))
                                                }
                                            </Col>
                                        }

                                        <Form onSubmit={this.onSaveDueDate}>
                                            {onAddFile ?
                                                <Col xs={24} align="end" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                        <Button onClick={this.cancelAddFile} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} >
                                                            ยกเลิก</Button>
                                                    </Col>
                                                    <Col span={8} align="end" style={{ width: '190px' }}>
                                                        <Button onClick={this.handleSubmit} className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
                                                            ส่งบันทึกหลังการประชุม</Button>
                                                    </Col>
                                                </Col>
                                                :
                                                <></>
                                            }

                                            <Col xs={24} className="my-5">
                                                <Row>
                                                    <p className="text-title-meeting ml-0 mb-0">กำหนดเวลาแสดงความเห็นชอบ</p>
                                                </Row>

                                                <Radio.Group onChange={this.onChangeTimeRadio} value={this.state.isSetTime}>
                                                    <Row className='my-3'>
                                                        <Radio value={false}>ไม่มีกำหนด</Radio>
                                                    </Row>
                                                    <Row className='my-3'>
                                                        <Radio value={true}>กำหนด</Radio>
                                                    </Row>
                                                </Radio.Group>

                                                <Row xs={24}>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="ml-2 meeting-date-picker" style={{ maxWidth: '170px' }}>
                                                        <Form.Item label="สิ้นสุด" className="mb-0">
                                                            {getFieldDecorator("endDate", {
                                                                initialValue: this.state.summaryDueDate || '',
                                                                rules: [
                                                                    {
                                                                        required: this.state.isSetTime,
                                                                        message: "กรุณาระบุ วันที่สิ้นสุด",
                                                                    },
                                                                ],
                                                            })(
                                                                <WatDatePicker
                                                                    onChange={this.onChangeEndDate}
                                                                    displayFormat={'DD MMMM YYYY'}
                                                                    clearable={false}
                                                                    minDate={moment()}
                                                                    disabled={!this.state.isSetTime || this.state.editTime}
                                                                    readOnly={false}
                                                                    yearBoundary={10} // number of boundary ±X Year
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="ml-2" style={{ maxWidth: '170px' }}>
                                                        <Form.Item label=" " required={false} className="mb-0">
                                                            {getFieldDecorator("endTime", {
                                                                initialValue: this.state.summaryDueDate ? moment(this.state.summaryDueDate) : '',
                                                                rules: [
                                                                    {
                                                                        required: this.state.isSetTime,
                                                                        message: "กรุณาระบุ เวลาสิ้นสุด",
                                                                    },
                                                                ],
                                                            })(
                                                                <TimePicker
                                                                    disabledHours={this.getDisabledHoursEnd}
                                                                    disabledMinutes={this.getDisabledMinutesEnd}
                                                                    format={'HH:mm'}
                                                                    className="w-100"
                                                                    placeholder=" "
                                                                    disabled={!this.state.isSetTime || this.state.editTime}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                {this.state.isSetTime || this.state.isSummaryDueDateActive ?
                                                    this.state.editTime ?
                                                        <Col xs={24} align="end" className='mt-3' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            <Col span={8} align="end" style={{ maxWidth: '150px' }}>
                                                                <Button onClick={this.onEditSetTime} className={'button-meeting-approve mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} >
                                                                    แก้ไข</Button>
                                                            </Col>
                                                        </Col>
                                                        :
                                                        <Col xs={24} align="end" className='mt-3' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            {this.state.isSetTime ?
                                                                <Col span={8} align="end" style={{ maxWidth: '100px' }}>
                                                                    <Button onClick={this.onCancelSetTime} className={'button-meeting-approve mt-lg-0'} style={{ color: "#808080", backgroundColor: "transparent" }} >
                                                                        ยกเลิก</Button>
                                                                </Col> : <></>}
                                                            <Col span={8} align="end" style={{ width: '100px' }}>
                                                                <Button htmlType='submit' className={'button-meeting-approve mt-3 mt-lg-0'} style={{ color: "#ffffff" }}>
                                                                    ยืนยัน</Button>
                                                            </Col>
                                                        </Col>
                                                    :
                                                    <></>
                                                }
                                            </Col>
                                        </Form>

                                        {dataMeeting.Comments && dataMeeting.Comments.length > 0 && (
                                            <Col xs={24}>
                                                <Col xs={24} className="pt-5" style={{ display: 'flex' }}>
                                                    <p className={'mr-3'} style={{ color: "#808080" }}>
                                                        <Icon type="like" /> เห็นชอบ ({`${countLike}/${GuestsInvite.length + OtherGuestsInvite.length}`})</p>
                                                    <p className={''} style={{ color: "#808080" }} >
                                                        <Icon type="message" /> แสดงความคิดเห็น ({`${countComment}/${GuestsInvite.length + OtherGuestsInvite.length}`})</p>
                                                </Col>
                                                {dataMeeting.Comments.map((comment) => {

                                                    return (
                                                        comment?.changeDetail ? (
                                                            <Col xs={24} className="mt-3 p-3">
                                                                <Row gutter={16} type="flex">
                                                                    <Col xs={20} className="p-3" style={{ backgroundColor: "#F2F2F2", borderRadius: "10px", width: 'fit-content', maxWidth: '600px' }}>
                                                                        {this.state.commentAccept ?
                                                                            <p className="text-name-message mb-2">{comment.title} {comment.firstName} {comment.lastName}</p>
                                                                            :
                                                                            <></>
                                                                        }
                                                                        <p className="text-note-message">{comment.changeDetail}</p>
                                                                        <p style={{ color: '#999999' }} className="text-note-message mb-0">{moment(comment.createDate || '').add(543, 'year').locale('th').format('DD MMMM YYYY / HH:mm น.')}</p>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        ) : <></>
                                                    )
                                                })}

                                            </Col>)}
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.modalConfirm}
                        onCancel={() => this.setState({ modalConfirm: false })}
                        footer={[
                            <Button key="back" className={'btn-modal-cancle'} onClick={() => this.setState({ modalConfirm: false })}>
                                ยกเลิก</Button>,
                            <Button key="submit" className={'btn-modal-confirm'} onClick={() => this.acceptAddFile(true)}>
                                ยืนยัน</Button>,
                        ]}
                        closable={false}
                    >
                        <div align="center">
                            <p style={{ fontSize: "20px" }}>
                                คุณต้องการส่ง<br />
                                บันทึกหลังการประชุม<br />
                                ใช่หรือไม่
                            </p>
                        </div>
                    </Modal>

                    <Modal
                        className={'meeting-management-modal'}
                        visible={this.state.modalSuccess}
                        onCancel={() => this.setState({ modalSuccess: false })}
                        footer={null}
                        closable={false}
                    >
                        <div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
                            <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
                            <p style={{ fontSize: "20px" }}>
                                ส่งบันทึกหลังการประชุมเรียบร้อย
                            </p>
                        </div>
                    </Modal>
                    <Modal
                        // maskClosable={false}
                        className={"meeting-invitee-modal"}
                        visible={this.state.showModalInvitee}
                        onCancel={this.onCloseModalInvitee}
                        closable={true}
                        title="รายชื่อผู้อนุมัติการประชุม "
                        footer={[
                            <Button
                                key="close"
                                className={"btn-modal-confirm"}
                                onClick={this.onCloseModalInvitee}
                            >
                                ปิด
                            </Button>
                        ]}
                    >
                        <div style={{ height: 400, width: 400, overflow: "auto", overflowX: "hidden" }}>
                            <Row gutter={16} className={"pt-0"}>
                                <Tabs defaultActiveKey="1" >
                                    <TabPane
                                        style={{ marginLeft: '2%' }}
                                        tab={`ผู้เข้าร่วมภายใน (${this.getLengthAcceptInternal(GuestsInvite)}/${this.getLength(GuestsInvite)})`} key="1">
                                        {GuestsInvite.map((element, i) => {
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.title} {element.firstName} {element.lastName}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.StatusResponse.statusName)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                    <TabPane
                                        tab={`ผู้เข้าร่วมภายนอก (${this.getLengthAcceptExternal(OtherGuestsInvite)}/${this.getLength(OtherGuestsInvite)})`} key="2">
                                        {OtherGuestsInvite.map((element, i) => {
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.name}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.asRole)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                </Tabs>
                            </Row>
                        </div>
                    </Modal>
                </Spin>
            </Container >
        )
    }
}

SentNoteMeetingForm.propTypes = {
    //
}

const WrappedSearchForm = Form.create()(SentNoteMeetingForm);
export default withApollo(WrappedSearchForm)